export default __webpack_public_path__ + "static/media/wa-1719-2.d88dc91a.jpg";